import React, { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { AutoForm } from '../../../playground/common/auto-form';
import { APV_SELECT_FIELDS } from './fields';
import { ApvSelectResultView } from './result-view';
import {
  ApvSelectFormValues,
  ApvSelectRegime,
  apvSelectDefaults,
  apvSelectSchema,
} from './schema';
import { buildApvSelectPayload, simulateApvSelect } from './service';

export function ApvSelectPage() {
  const [lastRequest, setLastRequest] = useState<unknown>(null);
  // Pinned at submit time, not read from the live form: the result view must
  // keep describing the regime the response was actually computed under, even
  // if the user flips the selector before re-simulating.
  const [lastRegime, setLastRegime] = useState<ApvSelectRegime>(apvSelectDefaults.regime);

  const mutation = useMutation({
    mutationFn: (values: ApvSelectFormValues) => simulateApvSelect(values),
  });

  const hasResult = mutation.isSuccess || mutation.isError;

  return (
    <>
      <div className="card">
        <div className="card-body">
          <AutoForm
            fields={APV_SELECT_FIELDS}
            schema={apvSelectSchema}
            defaults={apvSelectDefaults}
            isLoading={mutation.isLoading}
            onSubmit={(values) => {
              setLastRequest(buildApvSelectPayload(values));
              setLastRegime(values.regime);
              mutation.mutate(values);
            }}
          />
        </div>
      </div>

      {hasResult && (
        <ApvSelectResultView
          request={lastRequest}
          regime={lastRegime}
          response={mutation.data}
          error={mutation.isError ? mutation.error : undefined}
        />
      )}
    </>
  );
}
